import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';
import Modal from 'app/modal/v3';
import { BundleName, CardTitle, SpecText, EntitlementChip, ButtonRow, OutlineButton } from './styled';
import { detailLines, entitlementLabel } from './entitlements';
import { layout } from './tokens';

const STORE_URL = 'https://babyyearbooks.com';

// "Order details" — the breakdown behind the Details link on a book / gift tile.
// Upgrade and extra add-ons are bought on the storefront, not in the dashboard,
// so those actions link out rather than opening a purchase flow here.
const DetailsModal = ({ title, bundleName, entitlements, assignedAddOns, onClose }) => (
  <Modal
    title="Order details"
    close={{ onClose }}
    innerProps={{ maxWidth: layout.modalWidth }}
  >
    <Box px={[3, 4]} py={3} css="display: grid; grid-gap: 8px;">
      <CardTitle>{title}</CardTitle>
      {!!bundleName && <BundleName>{bundleName}</BundleName>}

      {detailLines(entitlements).map(line => (
        <SpecText key={line}>{line}</SpecText>
      ))}

      {!!assignedAddOns.length && (
        <Box css="display: flex; flex-direction: column; gap: 8px;" mt={2}>
          {assignedAddOns.map(addOn => (
            <EntitlementChip key={addOn.id}>{entitlementLabel(addOn)}</EntitlementChip>
          ))}
        </Box>
      )}
    </Box>
  </Modal>
);

DetailsModal.propTypes = {
  title: PropTypes.string.isRequired,
  bundleName: PropTypes.string,
  entitlements: PropTypes.object,
  assignedAddOns: PropTypes.array,
  onClose: PropTypes.func.isRequired,
};

DetailsModal.defaultProps = {
  bundleName: null,
  entitlements: {},
  assignedAddOns: [],
};

export default DetailsModal;
